import { render, staticRenderFns } from "./ExtraInfo.vue?vue&type=template&id=ccdec456&"
import script from "./ExtraInfo.vue?vue&type=script&lang=js&"
export * from "./ExtraInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExtraInfo.vue?vue&type=style&index=0&id=ccdec456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports